"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBasicUser = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const Card_1 = tslib_1.__importDefault(require("@mui/material/Card"));
const CardHeader_1 = tslib_1.__importDefault(require("@mui/material/CardHeader"));
const Avatar_1 = tslib_1.__importDefault(require("../Avatar"));
const InfoCardContent_1 = tslib_1.__importDefault(require("./InfoCardContent"));
/**
 *
 * @param user
 * @returns boolean
 *
 * Function to check if user is of type IBasicUserAdapter
 */
function isBasicUser(user) {
    if (user)
        return user.shortName !== undefined;
    return false;
}
exports.isBasicUser = isBasicUser;
/**
 *
 * An info card component that can show basic and extended information.
 * The info card has a loading state that will show an animated skeleton component.
 * It also has the possibility to show a skeleton component without animation if no user is provided as prop
 *
 * @example ### Basic example
 *
 * This examples shows a basic rendering of this component
 *
 * ```jsx live noInline
 * file://./__examples__/1_BasicInfoCardUser.jsx
 * ```
 *
 * @example ### Extended example
 *
 * This example shows a rendering with showExtended set to true
 *
 * ```jsx live noInline
 * file://./__examples__/2_ExtendedInfoCardUser.jsx
 * ```
 */
const InfoCardUser = (props) => {
    const { user, loading = false, AvatarProps, CardProps } = props;
    return (react_1.default.createElement(Card_1.default, { sx: { border: "none", boxShadow: "none" }, ...CardProps },
        react_1.default.createElement(CardHeader_1.default, { sx: { padding: 0, alignItems: "start" }, disableTypography: true, avatar: react_1.default.createElement(Avatar_1.default, { alt: user?.name ?? "-", loading: loading, sx: (theme) => ({ height: theme.spacing(6), width: theme.spacing(6) }), ...AvatarProps }), subheader: react_1.default.createElement(InfoCardContent_1.default, { ...props }) })));
};
exports.default = InfoCardUser;
